import './bootstrap';
import './forms';
import './questions';
import './answers';
import './nav';
import './auth';

import { capitalize } from './helpers';

String.prototype.capitalize = function() {
    return capitalize(this);
}

$(function() {
    $('body').tooltip({
        selector: '[data-toggle="tooltip"]'
    });
    // $('[data-toggle="tooltip"]').tooltip()
    
    // inicijalizacija tinymce rich text editora
    tinymce.init({
        selector: 'textarea.rich-description',
        menubar: false,
        // plugins: 'image code',
        // toolbar: "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | image | code",
        height: 300,
        content_style : 'span { background-color: transparent; }',
        icons_url: '/js/tinymce/icons/default/icons.min.js',
        skin_url: '/css/tinymce/skins/ui/oxide/',
        theme_url: '/css/tinymce/skins/ui/oxide/',
        content_css: '/css/tinymce/skins/content/default/content.min.css'
    });

    // kopiranje linka forme
    let clipboard = new ClipboardJS('[data-clipboard-text]');
    clipboard.on('success', function(e){
        // $('[data-clipboard-text] span.result').html(`
        //     <span class="fa fa-clipboard-check"></span>
        // `);
        $('[data-clipboard-text]').addClass('text-success');
        toastr.success('Successfully copied to clipboard.')
    });
});

// toggle password fielda ako je oznaceno da je forma privatna
$("#privateFormCheck").on('click', function(){
    $("#privateFormPassword").attr('disabled', !$(this).is(':checked'));
    $("#privateFormPasswordDiv").attr('hidden', !$(this).is(':checked'));
});

// toggle email fielda ako je oznaceno da je korisnik oznacio da zeli primati notifikacije
$("#notificationsCheck").on('click', function(){
    $("#notificationsEmail").attr('disabled', !$(this).is(':checked'));
    $("#notificationsEmailDiv").attr('hidden', !$(this).is(':checked'));
});


//  bootstrap counter charactera
$('input.with-counter').maxlength({
  alwaysShow: true, //if true the threshold will be ignored and the remaining length indication will be always showing up while typing or on focus on the input. Default: false.
 // threshold: 10, //Ignored if alwaysShow is true. This is a number indicating how many chars are left to start displaying the indications. Default: 10
  warningClass: "form-text text-muted mt-1", //it's the class of the element with the indicator. By default is the bootstrap "badge badge-success" but can be changed to anything you'd like.
  limitReachedClass: "form-text text-danger mt-1", //it's the class the element gets when the limit is reached. Default is "badge badge-danger". Replace with text-danger if you want it to be red.
  //separator: ' of ', //represents the separator between the number of typed chars and total number of available chars. Default is "/".
  //preText: 'You have ', //is a string of text that can be outputted in front of the indicator. preText is empty by default.
  //postText: ' chars remaining.', //is a string outputted after the indicator. postText is empty by default.
  showMaxLength: false, //showMaxLength: if false, will display just the number of typed characters, e.g. will not display the max length. Default: true.
  showCharsTyped: false, //if false, will display just the remaining length, e.g. will display remaining lenght instead of number of typed characters. Default: true.
  placement: 'bottom-right-inside', //is a string, object, or function, to define where to output the counter. Possible string values are: bottom ( default option ), left, top, right, bottom-right, top-right, top-left, bottom-left and centered-right. Are also available : **bottom-right-inside** (like in Google's material design, **top-right-inside**, **top-left-inside** and **bottom-left-inside**. stom placements can be passed as an object, with keys top, right, bottom, left, and position. These are passed to $.fn.css. A custom function may also be passed. This method is invoked with the {$element} Current Input, the {$element} MaxLength Indicator, and the Current Input's Position {bottom height left right top width}.

  //appendToParent: true, // appends the maxlength indicator badge to the parent of the input rather than to the body.
  //message: an alternative way to provide the message text, i.e. 'You have typed %charsTyped% chars, %charsRemaining% of %charsTotal% remaining'. %charsTyped%, %charsRemaining% and %charsTotal% will be replaced by the actual values. This overrides the options separator, preText, postText and showMaxLength. Alternatively you may supply a function that the current text and max length and returns the string to be displayed. For example, function(currentText, maxLength) { return '' + Math.ceil(currentText.length / 160) + ' SMS Message(s)';}
  //utf8: if true the input will count using utf8 bytesize/encoding. For example: the '£' character is counted as two characters.
  //showOnReady: shows the badge as soon as it is added to the page, similar to alwaysShow
  //twoCharLinebreak: count linebreak as 2 characters to match IE/Chrome textarea validation
  //customMaxAttribute: String -- allows a custom attribute to display indicator without triggering native maxlength behaviour. Ignored if value greater than a native maxlength attribute. 'overmax' class gets added when exceeded to allow user to implement form validation.
  //allowOverMax: Will allow the input to be over the customMaxLength. Useful in soft max situations.
});

// ajax za provjeru slug-a za forme
$('#formUrl').on('blur', function(){
    var slug = $(this).val();
    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: "POST",
        url: $path + "/forms/validateSlug" + $form_slug,
        data: {slug: slug},
        dataType: "json",
        success: function(data){
            $("#slug_success").html('<span class="fa fa-check"></span> ' + data.success);
            $("#slug_errors").html('');
        },
        error: function(data){
            // console.log(data);
            if(data.status === 422){
                $("#slug_success").html('');
                $("#slug_errors").html('<span class="fa fa-times"></span> ' + data.responseJSON.errors.slug[0]);
            }
        }
    });
});

// manipulacija opisom na formi
$('#formDescription').on('show.bs.collapse', function(){
    $('#formDescriptionToggle').removeClass('btn-secondary');
    $('#formDescriptionToggle').addClass('btn-danger');

    $('#formDescriptionToggleIcon').removeClass('fa-plus');
    $('#formDescriptionToggleIcon').addClass('fa-minus');

    $('#formDescriptionToggleText').text('Remove description');
});
$('#formDescription').on('hide.bs.collapse', function(){
    $('#formDescriptionToggle').removeClass('btn-danger');
    $('#formDescriptionToggle').addClass('btn-secondary');

    $('#formDescriptionToggleIcon').removeClass('fa-minus');
    $('#formDescriptionToggleIcon').addClass('fa-plus');

    $('#formDescriptionToggleText').text('Description');
    tinymce.activeEditor.setContent('');
});

// brisanje datoteka
$(document).on("click", ".fDelete", function(){
    const $file_id = $(this).data('file');
    const $question_id = $(this).data('question');

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: "DELETE",
        url: $path + $form_slug + '/questions/' + $question_id + '/files/destroy/' + $file_id,
        data: {},
        dataType: "json",
        success: function(data, status, xhr){
            // console.log('ovo je u success:', data);
            $('#filesTableContainer').load(' #filesTable');
            // loadFiles($question_id, $answer_id);
        },
        // error: function(data, status, xhr){
        //     console.log('ovo je u error:',xhr.url);
        // }
    });
});


$(document).on('mouseenter', '.file', function () {
    $(this).find(":button").show();
}).on('mouseleave', '.file', function () {
    $(this).find(":button").hide();
});
$(document).on('mouseenter', '.question-question', function () {
    $(this).find(":button").show();
}).on('mouseleave', '.question-question', function () {
    $(this).find(":button").hide();
});
$(document).on('mouseenter', '.question-description', function () {
    const button = $(this).find(":button");
    if(button.data('desc') == true) button.show();
}).on('mouseleave', '.question-description', function () {
    const button = $(this).find(":button");
    if(button.data('desc') == true) button.hide();
});

// question dropzone
// Dropzone.options.dropzone = {
//     maxFiles : 10,
//     parallelUploads: 10,
//     maxFilesize : 12,
//     uploadMultiple : true,
//     addRemoveLinks: true,
//     acceptedFiles : $mimes,

//     init: function(){
//         // const qDropzone = this;

//         this.on("addedfile", function(event) {
//             while (this.files.length > this.options.maxFiles) {
//                 $('#dropzone_errors').text('Maximum number of files for upload exceeded. Files that exceeded maximum count were removed.');
//                 this.removeFile(this.files[0]);
//             }
//         });

//         this.on("complete", function(){
//             $('#dropzone_errors').text('');
//         });

//         this.on("errormultiple", function(files, response){
//             // console.log(files, response);
//             $('#dropzone_errors').text(response.error);
//         });

//         this.on("successmultiple", function(files, response){
//             // console.log('ovo je u dropzone:', response);
//             $('#filesTableContainer').load(' #filesTable');
//         });

//         this.on("success", function(file, response){
//             const self = this;
//             $(file.previewElement).fadeOut({
//                 complete: function() {
//                   self.removeFile(file);
//                 }
//             });
//         });
//     }
// };


// triger changing avatar on clicking avatar image
$('#currentAvatar').on('click', function(){
    $('#avatarChange').trigger('click');
});
// $('#currentAvatar').on('hover', function(){
//     console.log('hovering');
// });
$('#avatarChange').on('change', function(){
    $('#avatarForm').submit();
});


// prevents clicking inside dropdown menu to hide it
// $(document).on('click', '.dropdown-menu', function (e) {
//   e.stopPropagation();
// });

// ajax to change password
$(document).on("click", "#changePasswordSave", function(){
    const $old_password = $('#oldPassword').val();
    const $password = $('#password').val();
    const $password_confirmation = $('#passwordConfirmation').val();

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: "PATCH",
        url: $path + '/settings/password',
        data: {old_password: $old_password, password: $password, password_confirmation: $password_confirmation},
        dataType: "json",
        success: function(data, status, xhr){
            // console.log('ovo je u success:', data);
            $('#oldPasswordErrors').text('');
            $('#oldPassword').val('');

            $('#passwordErrors').text('');
            $('#password').val('');

            $('#passwordConfirmationErrors').text('');
            $('#passwordConfirmation').val('');

            $('#alerts').html(`
                <div class="alert alert-success">
                    <strong>${data.success}</strong>
                </div>
            `);
            $('#changePasswordModal').modal('hide');
        },
        error: function(data, status, xhr){
            // console.log('ovo je u error:', data.responseJSON.errors);
            if(data.status === 422){
                $('#alerts').html('');
                $('#oldPasswordErrors').text(data.responseJSON.errors.old_password || '');
                $('#passwordErrors').text(data.responseJSON.errors.password || '');
                $('#passwordConfirmationErrors').text(data.responseJSON.errors.password_confirmation || '');
            } else if(data.status === 403){
                $('#alerts').html(`
                    <div class="alert alert-danger">
                        <strong>What you requested is forbidden.</strong>
                    </div>
                `);
                $('#changePasswordModal').modal('hide');
            } else {
                $('#alerts').html(`
                    <div class="alert alert-danger">
                        <strong>Something went wrong.</strong>
                    </div>
                `);
                $('#changePasswordModal').modal('hide');
            }
        }
    });
});

/* BUTTON FN LOADING */
$.fn.extend({
    showLoading: function() {
        this.each(function() {
            if(!this.dataset.loadingIcon) {
                const _color = this.classList.contains('btn-primary') ? 'text-pink' : 'text-primary'
                this.dataset.loadingIcon = `<i class="fa fa-circle-notch fa-spin m-auto ${_color}"></i>`
            }
            this.setAttribute('disabled', true)
            this.dataset.initialContent = this.innerHTML
            this.innerHTML = this.dataset.loadingIcon
        })
    },
    hideLoading: function() {
        this.each(function() {
            if(!this.dataset.initialContent) {
                console.error('Missing data-initial-content parameter.', this)
                return;
            }
            this.innerHTML = this.dataset.initialContent
            this.removeAttribute('disabled')
        })
    }
})
/* END FN BUTTON LOADING */
